import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginAttemptCollection } from '../models/ui/login-attempt-collection.model';
import { LoginTrackerSdk } from '../sdks/login-tracker.sdk';
import { ExportSdk } from '../sdks/export.sdk';

@Injectable({
	providedIn: 'root'
})
export class AdminManager {
	public loginAttemptCollection$: Observable<LoginAttemptCollection>;
	private loginAttemptCollectionSource: BehaviorSubject<LoginAttemptCollection> = new BehaviorSubject<LoginAttemptCollection>(null);

	constructor(private loginTrackerSdk: LoginTrackerSdk, private exportSdk: ExportSdk) {
		this.refreshLoginAttemptCollection();
		this.loginAttemptCollection$ = this.loginAttemptCollectionSource.asObservable();
	}

	public refreshLoginAttemptCollection(params: RefreshLoginAttemptCollectionParams = null): void {
		const sdkParams = {
				skip: params?.skip || 0,
				top: params?.take || 25
		};

		this.loginTrackerSdk.get(sdkParams).subscribe((response) => this.loginAttemptCollectionSource.next(response));
	}

	public exportLoginAttempts(): void {
		this.exportSdk.exportLoginTracker().subscribe((url) => {
			window.open(url, '_blank');
		});
	}
}

interface RefreshLoginAttemptCollectionParams {
	skip: number;
	take: number;
}




